// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"e4pKtb_wpwC65qb__EVn5"};